<div class="asset-notifications-container" [ngClass]="{ '!justify-between': asset.plannedDeletion && asset.expiryDate && (asset.publishStartDate || asset.publishEndDate) }" id="asset-notification">
  <!-- Planned deletion notification -->
  <ng-template [ngIf]="asset.plannedDeletion">
    <div class="mat-error flex items-center text-gray-500">
      <mat-icon class="text-lg material-icons-outlined mat-error mr-1">auto_delete</mat-icon>
      <span class="text-sm"><ng-container i18n>Planned for deletion on</ng-container> {{ asset.plannedDeletion | spDateFormat: { isSafe: true, plainDate: true } }}.</span>
    </div>
  </ng-template>
  <!-- Expiry date notification -->
  <ng-template [ngIf]="asset.expiryDate && (assetExpiryDays || assetExpiryDays === 0)">
    <div class="mat-error flex items-center text-gray-500" *ngIf="assetExpiryDays < 0">
      <mat-icon [ngClass]="{ '!text-[#F01F1F]': [CustomClients.SEAT, CustomClients.VKB, CustomClients.Standard].includes(brandingKey) }" class="text-lg material-icons-outlined mat-error mr-1"
        >warning_amber</mat-icon
      >
      <span [ngClass]="{ '!text-[#F01F1F]': [CustomClients.SEAT, CustomClients.VKB, CustomClients.Standard].includes(brandingKey) }" class="text-sm">
        <ng-container i18n>Asset expired on</ng-container> {{ asset.expiryDate | spDateFormat: { isSafe: true, plainDate: true } }}.
      </span>
    </div>
    <div class="mat-error flex items-center text-gray-500" *ngIf="assetExpiryDays <= 30 && assetExpiryDays > 0">
      <mat-icon [ngClass]="{ '!text-[#F01F1F]': [CustomClients.SEAT, CustomClients.VKB, CustomClients.Standard].includes(brandingKey) }" class="text-lg material-icons-outlined mat-error mr-1"
        >warning_amber</mat-icon
      >
      <span [ngClass]="{ '!text-[#F01F1F]': [CustomClients.SEAT, CustomClients.VKB, CustomClients.Standard].includes(brandingKey) }" class="text-sm">
        <ng-container i18n>Asset will expire on</ng-container> {{ asset.expiryDate | spDateFormat: { isSafe: true, plainDate: true } }}.
      </span>
    </div>
  </ng-template>
  <!-- Publishing details (if any) -->
  <ng-template [ngIf]="(asset.publishStartDate && !getIsAssetPublished(asset)) || asset.publishEndDate">
    <div class="mat-error flex items-center text-gray-500">
      <mat-icon class="text-lg material-icons-outlined mr-1">schedule</mat-icon>
      <span class="text-sm"> {{ asset | assetPublishingMessage }} </span>
    </div>
  </ng-template>
</div>
